import React, { FC } from 'react';
import { Box, CircularProgress, Unstable_Grid2 as Grid } from '@mui/material';

import { BillingPortalPlanType, BillingPortalRoute, useGetBillingUrlQuery } from 'api';
import { useCurrentUser, useNotify } from 'hooks';
import * as paths from 'paths';

const Billing: FC = () => {
  const notify = useNotify();
  const currentUser = useCurrentUser();
  const { location } = window;
  const returnUrl = `${location.protocol}//${location.host}${paths.adminAnalytics}`;

  const variables = {
    client_id: currentUser.client_id,
    user_id: currentUser.id,
    return_url: returnUrl,
    plan_type: BillingPortalPlanType.Teams,
    route: BillingPortalRoute.Overview,
  };

  useGetBillingUrlQuery(variables, {
    onError: () => notify.queryError(),
    onSuccess: ({ getBillingCustomerPortalEphemeralUrl }) => {
      window.location.href = getBillingCustomerPortalEphemeralUrl.url;
    },
  });

  return (
    <Box paddingBottom={4} paddingTop={4}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid>
          <CircularProgress />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Billing;
